import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HealthApiModels } from 'models/api/health-api.models';
import { SignatureApiModels } from 'models/api/signature-api.models';
import { HealthModels } from 'models/health.models';
import { PolicyModels } from 'models/policy.models';
import { Observable } from 'rxjs';
import { ConfigurationModels } from '../../../../../../models/configuration.models';
import { ApiServiceBase } from '../api-service-base';

@Injectable({
  providedIn: 'root',
})
export class HealthQuotationApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'health/healthquotations');
  }

  getPricingMetadatas(
    quotationRequest: HealthApiModels.QuotationRequest,
  ): Observable<HealthApiModels.HealthPolicyPricingMetadatasResponse> {
    return this.post<HealthApiModels.HealthPolicyPricingMetadatasResponse>(
      `/pricingMetadatas`,
      this.encryptData({
        quotationRequest,
      }),
    );
  }

  getSignatureInfo(publicId: string) {
    return this.getJson<HealthModels.HealthSignatureInfo>(
      `/${publicId}/signatureInfo`,
    );
  }

  signProposition(
    publicId: string,
    request: SignatureApiModels.SignDocumentRequest,
  ) {
    return this.post(`/${publicId}/signProposition`, request);
  }

  getPricing(
    req: HealthApiModels.QuotationPricingRequest,
  ): Observable<PolicyModels.PolicyPricing> {
    return this.post<HealthModels.HealthPolicyPricingMetadatas>(
      `/pricing`,
      this.encryptData(req),
    );
  }

  createQuotation(
    request: HealthApiModels.CreateQuotationRequest,
  ): Observable<string> {
    return this.post('/', this.encryptData(request));
  }

  getQuotation(publicId: string): any {
    return this.getJson(`/${publicId}`);
  }

  createProposition(
    publicId: string,
    subscriptionForm: HealthApiModels.CreateHealthPropositionRequest,
  ): any {
    return this.post(`/${publicId}/proposition`, subscriptionForm);
  }

  postSignedPropositionFile(publicId: string, files: File[]) {
    return this.postFormData(`/${publicId}/uploadSignedProposition`, {
      signedPropositionFiles: files,
    });
  }

  checkFraudeurPersonByName(assurePrincipal: any): Observable<any> {
    return this.post(
      `/CheckFraudeurPersonByName`,
      this.encryptData(assurePrincipal),
    );
  }
}
